export const environment = {
  production: false,

  clientId: '72od7ips2ovg2ks05lsmtg0gfa',
  region: 'us-east-1',
  identityPoolId: 'us-east-1:75052f5f-603c-42b8-a2cd-fa10583afc2e',
  userPoolId: 'us-east-1_fPD0iDcdm',

    urlBase: document.getElementsByTagName('base')[0].href,
    urlCognito: 'iccorp-dev.auth.us-east-1.amazoncognito.com',
    urlApi: 'https://dev-api-login.azurewebsites.net/',
    urlApiCanal: 'http://betaapirend.agilice.cl/',
    encodeKey: 'Iconstruye_nmp',
    idProductoDefecto: '72925772dd1451ad3c4722d0',
    recaptchaKey: '6LfDH60ZAAAAAGKOakXGGQVQ8AHfSrl-7dUYJMFD',

    urlBannerIConstruye: 'https://www.iconstruye.com',
    urlBannerAgilice: 'https://info.iconstruye.com/nuevo-acceso-clientes',
    urlBannerMarketplace: 'https://marketplace.iconstruye.com/',
    instrumentationKey: '482c2323-f4ca-4f21-9cbb-7cc72fbf9da6',
    applicationFullName: 'dev-spa-login'
};
